import vue from 'vue'
import msgmodal from './msgmodal'

const usemodal = vue.extend(msgmodal);
function showModal(options) {
    const _toast = new usemodal({
        data() {
            return {
                tagmodal:true,
                title:options.title,
                content:options.content,
                type:options.type
            }
        }
    });

    let element = _toast.$mount().$el;
    document.body.appendChild(element);
}

showModal.install = (Vue) => {
    Vue.prototype.$msgmodal = showModal
};
export default showModal
